




import React, { Component } from 'react';
import { can, canSeeRooms } from '../../permissions';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, THIS_URL, URL } from '../../variables';
import { maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdOutlineRule, MdReply, MdReport } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';
import TabPanel from "../ReusableComponents/TabPanel";
import TextReadMore from '../ReusableComponents/TextReadMore';
import { CircularProgress, Snackbar, Tab, Tabs } from "@material-ui/core";
import ModalRegras from './ModalRegras';
import Redacoes from '../Redacoes/Redacoes';
import Provas from '../Provas/Provas';
import CandidatosVinculados from '../CandidatosVinculados/CandidatosVinculados';
import CandidatosSaidas from '../CandidatosVinculados/CandidatosSaidas';
import VideoAIEvents from '../CandidatosVinculados/VideoAIEvents';

import FiscaisVinculados from '../FiscaisVinculados/FiscaisVinculados';
import CorretoresVinculados from '../CorretoresVinculados/CorretoresVinculados';
import SalasProcesso from '../SalasProcesso/SalasProcesso';
import AnalisesCandidatos from '../AnalisesCandidatos/AnalisesCandidatos';
import Downloads from '../Downloads/Downloads';
import QuestionariosVinculados from '../QuestionariosVinculados/QuestionariosVinculados';
import Diagramacoes from '../Diagramacoes/Diagramacoes';
import AvaliadoresVinculados from '../AvaliadoresVinculados/AvaliadoresVinculados';
import Entrevista from '../Entrevista/Entrevista';
import ProcessoConfiguracoes from '../ProcessoConfiguracoes/ProcessoConfiguracoes.js';


class ShowProcesso extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            path: '/',
            loading_screen: true,
            roles: [],
            name: '',
            caminho: '',
            termos: '',
            loading_save: false,
            msgErro: '',
            loading_image: false,
            faculdade: {},
            processo: {},
            show_more:false,

            activeTab: 0
        };

    }


    get_processo(id) {

        if (this.state.loading_screen == false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/faculdade/get_processo/${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ redirect: true });

                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                }
                else {
                    // this.props.mudarUser(resp.user);
                    this.setState({
                        loading_screen: false, 
                        faculdade: resp.processo.faculdade || {}, 
                        processo: resp.processo
                    });
                }

            } catch (err) {
                this.setState({ 
                    redirect: true,
                    loading_screen: false 
                });
                console.log(err);
            }

        })
            .catch((err) => {
                this.setState({ 
                    redirect: true,
                    loading_screen: false 
                });
                console.log(err);
            });
    }






    componentDidMount() {
        let tab = new URLSearchParams(this.props.location.search).get('tab');
        if (tab !== undefined && tab !== null) this.setState({ activeTab: parseInt(tab) });
        else if (tab === null) this.setState({ activeTab: 0 });
        this.get_processo(this.props.match.params.id);
    }







    render() {
        const allowedTabs = ["redacoes", "provas", "provas", "questionarios", "candidatos", "corretores", "fiscais", "candidatos", "candidatos", "avaliadores", "processo_seletivo", "entrevistas"].map(module => !module || can(this.props.user, module));
        allowedTabs[4] = canSeeRooms(this.props.user);
        allowedTabs[10] = can(this.props.user, 'processo_seletivo', 'edit');
        const selectedTab = allowedTabs[this.state.activeTab] ? this.state.activeTab : allowedTabs.findIndex(Boolean);
        if (this.state.loading_screen) return <SkeletonCoursePage />
        
        // Verificar se os dados necessários foram carregados
        if (!this.state.processo) {
            return <SkeletonCoursePage />
        }
        
        return (
          <div style={{ position: "relative" }}>
            <div className="card">
              <div className="card-body">
                <div className="hidethis" style={{ float: "right" }}>
                  <DefaultButton
                    bg="secondary"
                    text="Voltar"
                    icon={<RiArrowGoBackLine />}
                    to={`/instituicao/show/` + (this.state.processo?.faculdade_id || '')}
                  />
                </div>
                <div className="hidethis">
                  <div className="flex jcsb hidethis">
                    <h4 className="header">{this.state.processo.name}</h4>
                  </div>
                </div>

                <div className="hidethis">
                  <TextReadMore
                    title="Início: "
                    element="div"
                    limit={1000}
                    style={{
                      width: "100%",
                      marginBottom: 10,
                      whiteSpace: "pre",
                    }}
                  >
                    {moment(this.state.processo.inicio).format(
                      "DD/MM/YYYY HH:mm"
                    )}
                  </TextReadMore>
                  <TextReadMore
                    title="Encerramento: "
                    element="div"
                    limit={1000}
                    style={{
                      width: "100%",
                      marginBottom: 10,
                      whiteSpace: "pre",
                    }}
                  >
                    {moment(this.state.processo.fim).format("DD/MM/YYYY HH:mm")}
                  </TextReadMore>
                  <TextReadMore
                    title="Descrição: "
                    element="div"
                    limit={120}
                    style={{
                      width: "100%",
                      marginBottom: 10,
                      whiteSpace: "pre",
                    }}
                  >
                    {this.state.processo.descricao}
                  </TextReadMore>
                  <p
                    className="ver_regras"
                    onClick={() => {
                      this.setState({ show_more: true });
                    }}
                    style={{ marginRight: "2px" }}
                  >
                    {" "}
                    <b
                      style={{
                        float: "left",
                        marginRight: "2px",
                        color: "black",
                        marginRight: 2,
                      }}
                    >
                      Regras:{" "}
                    </b>{" "}
                    <MdOutlineRule /> {"Ver Regras"}{" "}
                  </p>
                  <ModalRegras
                    showModal={this.state.show_more}
                    setShowModal={(e) => this.setState({ show_more: e })}
                    processo_name={this.state.processo.name}
                    regras={this.state.processo.regras}
                  />

                  {this.props.user?.empresa?.online_proccess == true && (
                    <p>
                      <Button
                        style={{ width: "auto", marginRight: 10 }}
                        onClick={(e) => {
                          this.props.history.push({
                            pathname: `/instituicao/dashboard/${this.state.processo.faculdade_id}`,
                            search: `?processo_id=${this.state.processo.id}`,
                          });
                        }}
                        variant={"warning"}
                        size="sm"
                        className="flex align-center jcc"
                      >
                        <MdReport style={{ marginRight: 10 }} />{" "}
                        <p style={{ margin: 0 }}>Visualizar Relatórios</p>
                      </Button>
                    </p>
                  )}
                </div>

                {/* <div style={{ width: "100%", marginBottom: 10, whiteSpace: 'pre',height:this.state.show_more==false?100:'fit-content',overflowY:this.state.show_more==false? 'hidden':'visible' }}>
                            <b style={{ float: "left", marginRight: "2px" }}>{'Regras:'} </b>
                            <br/>
                            <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: this.state.processo.regras }}>
                            </div>
                        </div> */}
                {/* <div className="w100 flex align-center fdcolumn margin-bottom">
                            <div className="course-banner" style={{
                                backgroundImage: `url(${STORAGE_URL+ this.state.faculdade.logo})`,
                                backgroundSize: "contain",
                                backgroundRepeat:'no-repeat',
                                backgroundPositionX:'center',
                                width: "100%",
                                height: "200px",
                                borderRadius: "7px"
                            }} />
                        </div> */}
                {/* <br className='hidethis' />
                        <br className='hidethis' /> */}
                <div className="hidethis">
                  <Tabs
                    value={selectedTab}
                    onChange={(_, value) => {
                      this.setState({ activeTab: value });
                      this.props.history.push({ search: `?tab=${value}` });
                    }}
                    style={{ backgroundColor: "#ececf1" }}
                    indicatorColor="primary"
                    textColor="primary"
                    variant={"scrollable"}
                    scrollButtons={"on"}
                    className="hidethis"
                  >
                    <Tab style={{ display: allowedTabs[0] ? undefined : "none" }} className="hidethis" label="Redações" />
                    <Tab style={{ display: allowedTabs[1] ? undefined : "none" }} className="hidethis" label="Provas" />
                    <Tab style={{ display: allowedTabs[2] ? undefined : "none" }} label="Diagramações" />

                    {<Tab style={{ display: allowedTabs[3] ? undefined : "none" }} className="hidethis" label="Questionários" />}

                    {<Tab style={{ display: allowedTabs[4] ? undefined : "none" }} className="hidethis" label="Salas" />}
                    {<Tab style={{ display: allowedTabs[5] ? undefined : "none" }} className="hidethis" label="Corretores Vinculados" />}
                    {<Tab style={{ display: allowedTabs[6] ? undefined : "none" }} className="hidethis" label="Fiscais Vinculados" />}
                    {<Tab style={{ display: allowedTabs[7] ? undefined : "none" }} className="hidethis" label="Candidatos Vinculados" />}
                    <Tab style={{ display: allowedTabs[8] ? undefined : "none" }} className="hidethis" label="Eventos IA" />
                    <Tab style={{ display: allowedTabs[9] ? undefined : "none" }} className="hidethis" label="Avaliadores Vinculados" />
                    <Tab style={{ display: allowedTabs[10] ? undefined : "none" }} className="hidethis" label="Configurações" />
                    {this.state.processo.is_interview && (
                      <Tab style={{ display: allowedTabs[11] ? undefined : "none" }} className="hidethis" label="Entrevistas" />
                    )}

                    {/* {this.state.processo.online==true && <Tab className='hidethis' label="Saídas de Tela" />}

                            {this.state.processo.online==true && <Tab className='hidethis' label="Análises Faciais" />}
                            {this.state.processo.online==true && <Tab className='hidethis' label="Análises Objetos" />}

                            {this.state.processo.online==true && <Tab className='hidethis' label="Downloads" />} */}
                  </Tabs>
                </div>

                <TabPanel value={selectedTab} index={0}>
                  {allowedTabs[0] && <Redacoes
                    processo_id={this.state.processo.id}
                    processo_name={this.state.processo.name}
                    simulado={this.state.processo.simulado}
                  />}
                </TabPanel>
                <TabPanel value={selectedTab} index={1}>
                  {/* <Corretores faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                  {allowedTabs[1] && <Provas
                    processo_id={this.state.processo.id}
                    inicio={this.state.processo.inicio}
                    processo_name={this.state.processo.name}
                    simulado={this.state.processo.simulado}
                  />}
                </TabPanel>

                <TabPanel value={selectedTab} index={2}>
                  {allowedTabs[2] && <Diagramacoes
                    processo_id={this.state.processo.id}
                    processo_name={this.state.processo.name}
                  />}
                </TabPanel>

                {
                  <TabPanel value={selectedTab} index={3}>
                    {/* <Corretores faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                    {/* <Provas processo_id={this.state.processo.id} processo_name={this.state.processo.name} /> */}
                    {allowedTabs[3] && this.props.user?.empresa?.online_proccess == true &&
                      this.props.user.id != undefined &&
                      (this.props.user.role == "region_admin" ||
                        this.props.user.empresa == null ||
                        this.props.user.empresa.hide_questionario == false) && (
                        <QuestionariosVinculados
                          simulado={this.state.processo.simulado}
                          processo_id={this.state.processo.id}
                          processo_name={this.state.processo.name}
                        />
                      )}
                    {(this.props.user?.empresa?.online_proccess == false ||
                      !(
                        this.props.user.role == "region_admin" ||
                        this.props.user.empresa == null ||
                        this.props.user.empresa.hide_questionario == false
                      )) && (
                      <div>
                        <p style={{ textAlign: "center" }}>
                          Módulo não habilitado
                        </p>
                      </div>
                    )}
                  </TabPanel>
                }
                {
                  <TabPanel value={selectedTab} index={4}>
                    {/* <AddToCourse/> */}
                    {/* <Fiscais faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                    {allowedTabs[4] && <SalasProcesso
                      processo_id={this.state.processo.id}
                      processo_name={this.state.processo.name}
                    />}
                  </TabPanel>
                }
                {
                  <TabPanel value={selectedTab} index={5}>
                    {/* <AddToCourse/> */}
                    {/* <Fiscais faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                    {allowedTabs[5] && <CorretoresVinculados
                      processo_id={this.state.processo.id}
                      processo_name={this.state.processo.name}
                    />}
                  </TabPanel>
                }
                {
                  <TabPanel value={selectedTab} index={6}>
                    {/* <AddToCourse/> */}
                    {/* <Fiscais faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                    {allowedTabs[6] && !(
                      this.props.user?.empresa?.online_proccess == false ||
                      this.state.processo.online == false
                    ) && (
                      <FiscaisVinculados
                        processo_id={this.state.processo.id}
                        processo_name={this.state.processo.name}
                      />
                    )}
                    {(this.props.user?.empresa?.online_proccess == false ||
                      this.state.processo.online == false) && (
                      <p style={{ textAlign: "center" }}>
                        Módulo não habilitado
                      </p>
                    )}
                  </TabPanel>
                }
                {
                  <TabPanel value={selectedTab} index={7}>
                    {/* <Alunos faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                    {allowedTabs[7] && <CandidatosVinculados
                      online={this.state.processo.online}
                      processo_id={this.state.processo.id}
                      processo_name={this.state.processo.name}
                      faculdade={this.state.faculdade}
                    />}
                  </TabPanel>
                }

                <TabPanel value={selectedTab} index={8}>
                  {allowedTabs[8] && (this.props.user?.empresa?.online_proccess == true && this.state.processo.online == true ? (
                    <VideoAIEvents
                      processo_id={this.state.processo.id}
                    />
                  ) : (
                    <p style={{ textAlign: "center" }}>
                      Módulo não habilitado
                    </p>
                  ))}
                </TabPanel>

                <TabPanel value={selectedTab} index={9}>
                  {/* <Corretores faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                  {allowedTabs[9] && <AvaliadoresVinculados
                    processo_id={this.state.processo.id}
                    inicio={this.state.processo.inicio}
                    processo_name={this.state.processo.name}
                    simulado={this.state.processo.simulado}
                  />}
                </TabPanel>

                <TabPanel value={selectedTab} index={10}>
                  {allowedTabs[10] && (this.props.user?.empresa?.plan?.training == true ? <ProcessoConfiguracoes
                    processo_id={this.state.processo.id}
                    processo_name={this.state.processo.name}
                  />:
                   <p style={{ textAlign: "center" }}>
                        Módulo não habilitado
                      </p>)}
                </TabPanel>

                {this.state.processo.is_interview && (
                  <TabPanel value={selectedTab} index={11}>
                    {/* <Corretores faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                    {allowedTabs[11] && <Entrevista
                      processo_id={this.state.processo.id}
                      inicio={this.state.processo.inicio}
                      processo_name={this.state.processo.name}
                    />}
                  </TabPanel>
                )}

                {/* {this.state.processo.online==true && <TabPanel value={selectedTab} index={8}>
                            <CandidatosSaidas processo_id={this.state.processo.id} processo_name={this.state.processo.name} />

                        </TabPanel>}

                          {this.state.processo.online==true && <TabPanel value={selectedTab} index={9}>
                            <AnalisesCandidatos processo_id={this.state.processo.id} processo_name={this.state.processo.name} />

                        </TabPanel>}


                         {this.state.processo.online==true && <TabPanel value={selectedTab} index={10}>
                            <AnalisesCandidatosObjetos processo_id={this.state.processo.id} processo_name={this.state.processo.name} />

                        </TabPanel>}

                         {this.state.processo.online==true && <TabPanel value={selectedTab} index={11}>
                            <Downloads processo_id={this.state.processo.id} processo_name={this.state.processo.name} />

                        </TabPanel>} */}
              </div>
            </div>
          </div>
        );
    }


}
const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        user: state.AppReducer.user,

    }
);

const SkeletonCoursePage = () => {
    return (
        <div className="card">
            <div className="card-body">
                <div className="skeleton-title" />
                {/* <div className="skeleton-small-text skeleton-shimmer"/>
                <div className="skeleton-small-text skeleton-shimmer"/> */}
                <br />
                <div className="w100 flex jcc align-center">
                    <div className="skeleton-base skeleton-shimmer" style={{ width: "12em", height: "12em" }} />
                </div>
                <br />
                <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "48px" }} />
                <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "5em" }} />
                <div className="skeleton-small-button skeleton-shimmer" />
            </div>
        </div>
    );
}

export default connect(mapsStateToProps, { logout })(ShowProcesso);
